import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const StatusPurchaseOrderDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [PurchaseOrderStatusOptions, setPurchaseOrderStatusOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { purchaseOrderStatus, setPurchaseOrderStatus } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setPurchaseOrderStatus(
      parameters?.data?.filter((item) => item.type === "purchaseOrderStatus")
    );
  }, [parameters]);

  useEffect(() => {
    setPurchaseOrderStatusOptions(
      purchaseOrderStatus.map((item: Parameter) => ({
        label: item.value,
        value: item.value === "Ativo" ? "true" : "false",
      }))
    );
  }, [purchaseOrderStatus]);

  return (
    <Dropdown
      value={options.value}
      options={PurchaseOrderStatusOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o status"
      showClear
    />
  );
};
export default StatusPurchaseOrderDropdown;
